module.exports = __webpack_public_path__ + "12de74e119472638f02b30eba6abd0ad.pdf";